import { CopySimple } from "@phosphor-icons/react";
import { toast } from "react-toastify";

import { Button } from "common/components/ui/Button";
import { DialogTitle } from "common/components/ui/Dialog";
import { DrawerTitle } from "common/components/ui/Drawer";
import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";
import useWorkspaceToken from "common/datahooks/useWorkspaceToken";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

const brandUrl = import.meta.env.VITE_WHITE_LABEL_URL;

interface BrandedLoginUrlProps {
  goBack: () => void;
  accountId?: string;
}

export default function BrandedLoginUrl({
  goBack,
  accountId = null,
}: BrandedLoginUrlProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { workspaceToken, isLoadingWorkspaceToken } = useWorkspaceToken({
    accountId,
  });

  const URL = `${brandUrl}${workspaceToken ? `#${workspaceToken}` : ""}`;

  function copyLink() {
    navigator.clipboard.writeText(URL);

    toast.success("Copied URL");
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;

  return (
    <>
      <Title className="mb-8">{accountId ? "Reconnect" : "Connect"} URL</Title>
      <FormField
        label="URL"
        size={isDesktop ? "md" : "lg"}
        htmlFor="brandedLoginUrl"
        hint={
          !!accountId &&
          "This generates a reconnect link for this specific account"
        }
      >
        <div className="flex gap-x-2.5">
          <Input
            id="brandedLoginUrl"
            value={isLoadingWorkspaceToken ? "Generating URL..." : URL}
            disabled
            className="flex-1"
            variant={isDesktop ? "md" : "lg"}
          />
          <Button
            variant="secondary-black"
            intent="iconOnly"
            onClick={copyLink}
            size={isDesktop ? "md" : "lg"}
          >
            <CopySimple />
          </Button>
        </div>
      </FormField>

      <div className="mt-8 flex justify-between gap-x-2.5">
        <Button
          className="lg:flex-1"
          variant="secondary-black"
          size={isDesktop ? "md" : "lg"}
          onClick={goBack}
        >
          Back
        </Button>
        <Button
          className="lg:flex-1"
          onClick={copyLink}
          size={isDesktop ? "md" : "lg"}
          isLoading={isLoadingWorkspaceToken}
        >
          Copy
        </Button>
      </div>
    </>
  );
}
